const ROOT_STRING = 'easygestorweb_';

const rootKeys = {
    APIKEY: `${ROOT_STRING}apikey`,
    IS_FISCAL: `${ROOT_STRING}current_branch_is_fiscal`,
    ALL_BRANCHES: `${ROOT_STRING}all_branches`,
    REFRESH_TOKEN: `${ROOT_STRING}refresh_token`,
    USER_DATA: `${ROOT_STRING}userdata`,
    CURRENT_BRANCH: `${ROOT_STRING}current_branch`,
    CURRENT_BRANCH_ID: `${ROOT_STRING}current_branch_id`,
    CURRENT_BRANCH_FANCY_NAME: `${ROOT_STRING}current_branch_fancy_name`,

    BRANCH_SERIES:  `${ROOT_STRING}branch_series`,
    CURRENT_BRANCH_SERIE:  `${ROOT_STRING}current_branch_serie`,
    NFE_CONFIG:  `${ROOT_STRING}nfe_branch_config`,
    NFCE_CONFIG:  `${ROOT_STRING}nfce_branch_config`,

    CLIENTS: `${ROOT_STRING}clients`,
    LAST_SALES: `${ROOT_STRING}last_sales`,

    CONFIG: `${ROOT_STRING}branch_config`,
    PRODUCTS:`${ROOT_STRING}products` , 

    //POS
    PRODUCTS_TO_SALE: `${ROOT_STRING}_products_to_sale`,
    ITEMS_TO_SALE: `${ROOT_STRING}_items_to_sales`,
    DISCOUNT_TYPE: `${ROOT_STRING}_pos_discount_type`,
    DISCOUNT_INPUT_VALUE: `${ROOT_STRING}_pos_discount_input`,
    DISCOUNT_VALUE: `${ROOT_STRING}_pos_discount_value`,
    POS_CLIENT: `${ROOT_STRING}_pos_client`,
    POS_SALESPERSON: `${ROOT_STRING}_salesperson`,
    CLIENT_DOCUMENT: `${ROOT_STRING}_client_document`,

    UNITS: `${ROOT_STRING}units`,
    CATEGORIES: `${ROOT_STRING}categories`,
    SUPPLIERS: `${ROOT_STRING}suppliers`,

    PLANS: `${ROOT_STRING}plans`,
    CERTIFICATES: `${ROOT_STRING}certificates`,

    EASYGESTOR: 'EasyGestor® ',
    
    SALES: `${ROOT_STRING}sales`,
    PAYMENT_METHODS: `${ROOT_STRING}payment_methods`,

    RESENT_NFE: `${ROOT_STRING}resent_nfe`
};
export default rootKeys;

const mapKeys = [
    rootKeys.APIKEY,
    rootKeys.REFRESH_TOKEN,
    rootKeys.USER_DATA,
    rootKeys.CURRENT_BRANCH_ID,
    rootKeys.CURRENT_BRANCH_FANCY_NAME,
    rootKeys.PRODUCTS_TO_SALE,
    rootKeys.PRODUCTS,
    rootKeys.CATEGORIES,
    rootKeys.SALES,
    rootKeys.ITEMS_TO_SALE,
    rootKeys.DISCOUNT_VALUE,
    rootKeys.DISCOUNT_TYPE,
    rootKeys.POS_CLIENT,
    rootKeys.POS_SALESPERSON,
    rootKeys.CLIENT_DOCUMENT,
    rootKeys.SUPPLIERS,
    rootKeys.IS_FISCAL,
    rootKeys.CONFIG,
    rootKeys.ALL_BRANCHES,
    rootKeys.UNITS,
    rootKeys.CURRENT_BRANCH,
    rootKeys.PAYMENT_METHODS,
    rootKeys.PLANS,
    rootKeys.CERTIFICATES,
    rootKeys.RESENT_NFE
];

export { mapKeys };



// WEBPACK FOOTER //
// ./src/sources/consts/index.jsx